export const config = {
  eventGroup: 'seasungames_job_pc_20240830',
  name: '企业站招聘站pc端',
  identify: 'xishanju_com',
  eventTags: ['seasungames', 'pc', 'job']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageXqjz: function() {
      report({
        eventName: 'load_page_xqjz',
        eventDescription: '简历编辑-页面加载',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageLbjz: function() {
      report({
        eventName: 'load_page_lbjz',
        eventDescription: '职位列表-页面加载',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageBjjz: function() {
      report({
        eventName: 'load_page_bjjz',
        eventDescription: '简历编辑-页面加载',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickDldl: function() {
      report({
        eventName: 'click_dldl',
        eventDescription: '顶栏-登录',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickTdjl: function() {
      report({
        eventName: 'click_tdjl',
        eventDescription: '职位详情-投递简历',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickBjqx: function() {
      report({
        eventName: 'click_bjqx',
        eventDescription: '简历编辑-取消按钮',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickBjyl: function() {
      report({
        eventName: 'click_bjyl',
        eventDescription: '简历编辑-预览按钮',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickYlbj: function() {
      report({
        eventName: 'click_ylbj',
        eventDescription: '简历预览-编辑简历按钮',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickYltd: function() {
      report({
        eventName: 'click_yltd',
        eventDescription: '简历预览-投递简历按钮',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageTdcg: function() {
      report({
        eventName: 'load_page_tdcg',
        eventDescription: '投递成功-页面加载',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageYpjl: function() {
      report({
        eventName: 'load_page_ypjl',
        eventDescription: '应聘记录-页面加载',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickJxyz: function() {
      report({
        eventName: 'click_jxyz',
        eventDescription: '应聘记录-进行验证',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
